export default __webpack_public_path__ + "static/media/muesliBar.ff75f18b.jpg";